import { ReviewRepository } from "../../repositories/ReviewRepository";
import { ReviewRequestEntity } from "../../entities/ReviewEntity";

/**
 * Get Pending Reviews Use Case
 * Retrieves pending reviews for current user (as reviewer)
 */
export class GetPendingReviewsUseCase {
  constructor(private repository: ReviewRepository) {}

  async execute(): Promise<ReviewRequestEntity[]> {
    return await this.repository.getPendingReviews();
  }
}
